import React from "react";
import { Modal, Row, Col, Button } from "antd";
import styles from "./PersonModals.module.scss";
import { useWindowSize } from "../../../hooks/useWindowSize";

type Props = {
  visible: boolean;
  setVisibility: Function;
};

function InvalidEmailModal({ visible, setVisibility }: Props) {
  const { width } = useWindowSize();

  function handleClose() {
    setVisibility(false);
  }

  return (
    <Modal
      visible={visible}
      className={styles.invalidEmailModalContainer}
      centered={width < 992}
      width={width < 992 ? "unset" : "547px"}
      footer={
        <Row justify="center">
          <Col>
            <Button className={styles.close} onClick={handleClose}>
              Close
            </Button>
          </Col>
        </Row>
      }
    >
      <Row justify="center" className={styles.title}>
        Account Already Exists
      </Row>
      <Row justify="center">
        <Col xs={3} lg={0} />
        <Col xs={18} lg={24} className={styles.description}>
          An account with this email address already exists. Please enter a
          different email address or Cancel changes to the Caregiver's profile.
        </Col>
        <Col xs={3} lg={0} />
      </Row>
    </Modal>
  );
}

export default InvalidEmailModal;
